import styled, { css } from "styled-components";
import { color } from "../../styles";

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabHeader = styled.div`
  display: flex;
  position: relative;
  gap: 4px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 8px;
`;

export const Tab = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 0 2px;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.active ? color.primary.BLUE_B100 : "#333333")};
  transition: all 0.3s ease;
  border-bottom: 2px solid
    ${(props) => (props.active ? color.primary.BLUE_B100 : "transparent")};

  div.text {
    border-radius: 4px;
    padding: 6px 16px;

    &:hover {
      background: rgba(0, 0, 0, 0.07);
    }
  }
`;

export const TabContent = styled.div<{
  active: boolean;
  direction: "right";
}>`
  padding-top: 16px;
  width: 100%;
  display: ${({ active }) => (active ? "block" : "none")};
`;
